import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { BrandService } from 'src/app/api/catalog/brand.service';
import { GlobalService } from 'src/app/api/global.service';
import { SearchComponent } from 'src/app/components/search/search.component';
import { NavigationTrackerService } from 'src/app/utils/navigation-tracker.service';
import SwalAlert from 'src/app/utils/swalalert';
import AlertifyHelper from 'src/app/utils/utils';
declare var $: any;
import * as moment from 'moment';
import { HotelbookingsService } from 'src/app/api/hotelbooking/hotelbookings.service';
import { CalendarOptions } from '@fullcalendar/core';
import resourceTimelinePlugin from '@fullcalendar/resource-timeline';
import interactionPlugin from '@fullcalendar/interaction';
import esLocale from '@fullcalendar/core/locales/es'; // ✅ esta ruta sí existe

@Component({
  selector: 'app-hotelbookings-list',
  templateUrl: './hotelbookings-list.component.html',
  styleUrls: ['./hotelbookings-list.component.css']
})
export class HotelbookingsListComponent implements OnInit {
  private thisComponent: HotelbookingsListComponent;
  branchofficeSlug = '';
  items: any = [];
  params: any = {
    search: ''
  };
  page = 1;
  count = 0;

  @ViewChild(SearchComponent) searchComponent: any;

  dataPagination: any = {
    pageSize: 0,
    currentPage: this.page,
    totalItems: 0
  };

  start_range: any = moment();
  end_range: any = moment().endOf('month');
  date_now: any = moment().format('YYYY-MM-DD');

  // variables
  total_breakfast: any = 0;
  total_checkin: any = 0;
  total_checkout: any = 0;

  constructor(
    private routeActivated: ActivatedRoute,
    private navigationTrackerService: NavigationTrackerService,
    private hotelbookingService: HotelbookingsService,
    private router: Router,
    private globalService: GlobalService,
    private alert: SwalAlert,
    private alertifyMsg: AlertifyHelper
  ) {
    this.thisComponent = this;
    this.branchofficeSlug = this.globalService.slugBranchoffice;
  }

  ngOnInit() {
    this.generateCalendar();
    this.list();
    this.navigationTrackerService.initializeMenu(this.routeActivated);
    (<any>$('[data-toggle="tooltip"]')).tooltip();
  }

  generateCalendar() {
    let component_ = this.thisComponent;
    (<any>$('#date_range'))
      .daterangepicker({
        singleDatePicker: true,
        showDropdowns: true,
        autoApply: true,
        startDate: moment().format('YYYY-MM-DD'),
        locale: {
          format: 'YYYY-MM-DD'
        }
      })
      .on('apply.daterangepicker', function(ev: any, picker: any) {
        component_.start_range = picker.startDate;
        component_.list();
      });
  }

  list() {
    let val_params =
      'search=' +
      this.params.search +
      '&page=' +
      this.page +
      '&start_range=' +
      this.start_range.format('YYYY-MM-DD');

    this.hotelbookingService.list(val_params).subscribe({
      next: (data: any) => {
        console.log(data);
        this.items = data.results;

        // Calcular total de desayunos
        const total_breakfast = this.items
          .filter((ev: any) => ev.is_checkin === true)
          .reduce((sum: number, ev: any) => sum + (Number(ev.nro_pax) || 0), 0);
        this.total_breakfast = total_breakfast;

        // Calcular total de reservas para checkin acorde fecha
        this.total_checkin = this.items.filter(
          (ev: any) =>
            ev.is_checkin === false &&
            moment(ev.date_checkin).format('YYYY-MM-DD') ===
              this.start_range.format('YYYY-MM-DD')
        ).length;

        // Calcular total de reservas para checkout acorde fecha
        this.total_checkout = this.items.filter(
          (ev: any) =>
            ev.is_checkin === true &&
            ev.is_checkout === false &&
            moment(ev.date_checkout).format('YYYY-MM-DD') ===
              this.start_range.format('YYYY-MM-DD')
        ).length;

        setTimeout(() => {
          (<any>$('[data-toggle="tooltip"]')).tooltip();
        }, 150);
      }
    });
  }

  isBefore(date1: any, date2: any): boolean {
    if (!date1 || !date2) return false;
    return new Date(date1) < new Date(date2);
  }

  isAfter(date1: any, date2: any): boolean {
    if (!date1 || !date2) return false;
    return new Date(date1) > new Date(date2);
  }

  checkIn(item: any) {
    let options = {
      title: '¿Estás segur@?',
      message:
        '¿Esta seguro(a) de confirmar el CHECK-IN de la reserva de la HAB ' +
        item.bedroom.code_number +
        '?',
      cancel: 'Cancelar',
      confirm: 'Confirmar CHECK-IN'
    };
    this.alert.confirmCheckinInfo(options).then((result: any) => {
      if (result.isConfirmed) {
        this.hotelbookingService.checkin(item.id, item).subscribe({
          next: (data: any) => {
            this.alertifyMsg.success('CHECK-IN realizado con éxito !');
            this.list();
          }
        });
      }
    });
  }

  checkOut(item: any) {
    let options = {
      title: '¿Estás segur@?',
      message:
        '¿Esta seguro(a) de confirmar el CHECK-OUT de la reserva de la HAB ' +
        item.bedroom.code_number +
        '?',
      cancel: 'Cancelar',
      confirm: 'CONFIRMAR CHECK-OUT'
    };
    this.alert.confirmCheckoutInfo(options).then((result: any) => {
      if (result.isConfirmed) {
        // this.bookingsService.checkout(this.book.id, this.book).subscribe({
        //   next: (data: any) => {
        //     this.alertifyMsg.success('ANULACIÓN realizado con éxito !');
        //     this.editData(data.data.id);
        //   }
        // });
      }
    });
  }

  search(text: any) {
    this.params.search = text;
    this.page = 1;
    this.list();
  }

  handlePageChange(event: any): void {
    this.page = event;
    this.list();
  }

  refresh() {
    this.page = 1;
    this.params.search = '';
    this.searchComponent.textSearch = '';
    this.start_range = moment();
    this.generateCalendar();
    this.list();
  }

  detail(id: number) {
    this.router.navigate([
      this.branchofficeSlug + '/reservashotel/reservas/detalle',
      id
    ]);
  }

  edit(id: number) {
    this.router.navigate([
      this.branchofficeSlug + '/reservashotel/reservas/editar',
      id
    ]);
  }
  

  delete(item: any, _index: any) {
    let options = {
      title: '¿Estás segur@?',
      message: item.description,
      cancel: 'Cancelar',
      confirm: 'Eliminar'
    };
    this.alert.confirmDelete(options).then((result: any) => {
      if (result.isConfirmed) {
        this.hotelbookingService.delete(item.id).subscribe({
          next: (data: any) => {
            this.items.splice(_index, 1);
            this.alertifyMsg.success(
              'El registro ' + item.description + ' se ha eliminado con éxito'
            );
            this.list();
          }
        });
      }
    });
  }
}
